import styled from 'styled-components'

const ExhibitionsStyle = styled.div.attrs(props => ({ className: props.className }))`

	.top-section {
		padding-bottom: var(--sp28x);
		align-items: center;
		position: relative;

		.imageCont {
			position: absolute;
			z-index: 1;

			& > span {
				transition: var(--trTime) cubic-bezier(.66, 0, 0.34, 1);
			}

			&.picture1 {
				width: 18%;
				padding-top: 18%;
				right: -3%;
				top: 30%;

				&.activeImage {
					& > span {
						transform: translate(-140%, -30%);
					}
				}
			}

			&.picture2 {
				width: 25%;
				padding-top: 25%;
				left: -4%;
				top: -2.8%;

				&.activeImage {
					& > span {
						transform: translate(80%, 20%);
					}
				}
			}

			&.picture3 {
				width: 20%;
				padding-top: 18%;
				bottom: 10%;
				left: 1%;

				&.activeImage {
					& > span {
						transform: translate(100%,-100%);
					}
				}
			}

			&.butterfly1 {
				width: 13%;
				padding-top: 13%;
				right: 13%;
				top: 33%;

				&.activeImage {
					& > span {
						transform: translate(-100%, -60%);
					}
				}
			}

			&.butterfly2 {
				width: 13%;
				padding-top: 13%;
				left: -4%;
				top: 33%;

				&.activeImage {
					& > span {
						transform: translate(155%,-55%);
					}
				}
			}

			&.angel {
				width: 16%;
				padding-top: 17%;
				left: 9%;
				top: 34%;

				&.activeImage {
					& > span {
						transform: translate(110%, 100%);
					}
				}
			}

			&.elephant{
				width: 9%;
				padding-top: 8%;
				right: 2%;
				bottom: 31%;

				&.activeImage {
					& > span {
						transform: translate(-150%, -60%);
					}
				}
			}
			
			&.coin {
				width: 11%;
				padding-top: 11%;
				right: 13%;
				top: 11%;

				&.activeImage {
					& > span {
						transform: translate(-100%,20%);
					}
				}
			}
		}
		
		.Title {
			display: flex;
			flex-direction: column;
			align-items: center;
			align-self: center;
			margin:var(--sp13x) 0 var(--sp7x);
			z-index: 2;
			pointer-events: none;

			& > span {
				align-items: center;
				
			}
		}

		.text-1 {
			max-width: var(--sp97x);
			transform: translateX(-40%);
			z-index: 2;
			pointer-events: none;
		}
		
		.texts {
			transform: translateX(40%);
			z-index: 2;
			pointer-events: none;

			.text-2 {
				max-width: var(--sp98x);
				margin:var(--sp7x) 0 var(--sp9x);
			}
			
			.text-3 {
				max-width: var(--sp149x);
			}
		}
	}

	.exhibition {
		padding:var(--sp28x) 0;
		
		&.work {
			color: var(--backColor);
			background-color:#F8C6A4 ;

			.table {
				.imageCont {
					transform: translateY(-50%) rotate(15deg);
				}
				
				.table-heading {
					border-bottom: 1px solid var(--backColor);
					
				}

				.works {
					.single-work {
						border-bottom: 1px solid var(--backColor);
					}
				}
			}
		}

		.title {
			padding-left: var(--containerPadding);
			padding-right: var(--containerPadding); 
		}

		.table {
			margin-top: var(--sp7x);
			position: relative;

			.imageCont {
				position: absolute;
				right: -5%;
				top: 50%;
				transform: translateY(-50%) rotate(-15deg);
				width: 20.4%;
				padding-top: 14.1%;
			}

			.table-heading {
				padding-left: var(--containerPadding);
				padding-right: var(--containerPadding);
				padding-bottom: var(--sp4x);
				border-bottom: 1px solid var(--textColor);

				.comp-title {
					padding-right:var(--sp3x);
				}
				
				.year {
					width: 15%;
				}
				.city {
					width: 20%;
				}
				.ex {
					width: 30%;
				}
				
				.gallery {
					width: 35%;
				}
			}

			.works {
				.single-work {
					padding:var(--sp4x) var(--containerPadding);
					border-bottom: 1px solid var(--textColor);
					overflow: hidden;

					&.active {
						.year {
							transform:translateY(0);
						}
						.city {
							transform:translateY(0);
						}
						.ex {
							transform:translateY(0);
						}
						
						.gallery {
							transform:translateY(0);
						}	
					}

					@media screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}){
						&:hover *  {
							font-family: ${(props) => props.isArm ? 'GHEAMariamBold' : 'NotoSansBold'} ;
						}
					}
					
					.comp-title {
						padding-right:var(--sp3x);
					}

					.year {
						width: 15%;
						transform:translateY(200%);
						transition:var(--trTime2);
					}
					.city {
						width: 20%;
						transform:translateY(200%);
						transition:var(--trTime2);
					}
					.ex {
						width: 30%;
						transform:translateY(200%);
						transition:var(--trTime2);
					}
					
					.gallery {
						width: 35%;
						transform:translateY(200%);
						transition:var(--trTime2);
					}
				}
			}

		}

		.btn-cont {
			align-self:center;
		}
	}

    @media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeM}) {
		.top-section {
			padding-bottom: var(--sp25x);

			.Title {
				margin:var(--sp10x) 0 var(--sp6x);
			}

			.text-1 {
				max-width: var(--sp72x);
			}
			
			.texts {
				.text-2 {
					max-width: var(--sp72x);
					margin:var(--sp6x) 0 var(--sp8x);
				}
				
				.text-3 {
					max-width: var(--sp129x);
				}
			}
		}

		.exhibition {
			padding:var(--sp25x) 0;
			
			.table {
				margin-top: var(--sp6x);

				.imageCont {
					right: -3%;
					width: 22.2%;
    				padding-top: 15.4%;
				}

				.table-heading {
					padding-bottom: var(--sp3x);
				}

				.works {
					.single-work {
						padding:var(--sp3x) var(--containerPadding);
					}
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeS}) {
		.top-section {
			padding-bottom: var(--sp20x);

			.Title {
				margin:var(--sp9x) 0 var(--sp5x);
			}

			.text-1 {
				max-width: var(--sp67x);
			}
			
			.texts {

				.text-2 {
					max-width: var(--sp67x);
					margin:var(--sp5x) 0 var(--sp7x);
				}
				
				.text-3 {
					max-width: var(--sp96x);
				}
			}
		}

		.exhibition {
			padding:var(--sp20x) 0;
			
			.table {
				margin-top: var(--sp5x);

				.imageCont {
					right: -4%;
					width: 22.2%;
    				padding-top: 15.4%;
				}

				.table-heading {
					padding-bottom: var(--sp3x);
				}

				.works {
					.single-work {
						padding:var(--sp3x) var(--containerPadding);
					}
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.DesktopSizeXS}) {
		.top-section {
			padding-bottom: var(--sp18x);

			.Title {
				margin:var(--sp8x) 0 var(--sp4x);
			}

			.text-1 {
				max-width: var(--sp58x);
			}
			
			.texts {

				.text-2 {
					max-width: var(--sp58x);
					margin:var(--sp4x) 0 var(--sp5x);
				}
				
				.text-3 {
					max-width: var(--sp85x);
				}
			}
		}

		.exhibition {
			padding:var(--sp18x) 0;
			
			.table {
				margin-top: var(--sp4x);

				.imageCont {
					right: -4%;
					width: 22.2%;
    				padding-top: 15.4%;
				}

				.table-heading {
					padding-bottom: var(--sp3x);
				}

				.works {
					.single-work {
						padding:var(--sp3x) var(--containerPadding);
					}
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
        props.theme.mediaQuery.TabletSize}) {
		.top-section {
			padding-bottom: var(--sp15x);

			.Title {
				margin:var(--sp7x) 0 var(--sp3x);
			}

			.text-1 {
				max-width: var(--sp57x);
				transform: translateX(-25%);
			}
			
			.texts {
				transform: translateX(25%);
				.text-2 {
					max-width: var(--sp57x);
					margin:var(--sp3x) 0 var(--sp4x);
				}
				
				.text-3 {
					max-width: var(--sp80x);
				}
			}

			@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSize}){
				.imageCont {

					& > span {
						transition: var(--trTime) cubic-bezier(.66, 0, 0.34, 1);
					}

					&.picture1 {
						width: 18%;
						padding-top: 18%;
						right: -3%;
						top: 20%;

						&.activeImage {
							& > span {
								transform: translate(0, 0);
							}
						}
					}

					&.picture2 {
						width: 22%;
						padding-top: 22%;
						left: -4%;
						top: 3%;

						&.activeImage {
							& > span {
								transform: translate(0, 0);
							}
						}
					}

					&.picture3 {
						bottom: 30%;

						&.activeImage {
							& > span {
								transform: translate(0, 0);
							}
						}
					}

					&.butterfly1 {
						width: 13%;
						padding-top: 13%;
						right: 13%;
						top: 23%;

						&.activeImage {
							& > span {
								transform: translate(0, 0);
							}
						}
					}

					&.butterfly2 {
						width: 13%;
						padding-top: 13%;
						left: -4%;
						top: 33%;

						&.activeImage {
							& > span {
								transform: translate(0, 0);
							}
						}
					}

					&.angel {
						width: 16%;
						padding-top: 17%;
						left: 9%;
						top: 34%;

						&.activeImage {
							& > span {
								transform: translate(0, 0);
							}
						}
					}

					&.elephant{
						width: 11%;
						padding-top: 10%;
						right: 2%;
						bottom: 44%;

						&.activeImage {
							& > span {
								transform: translate(0, 0);
							}
						}
					}
					
					&.coin {

						&.activeImage {
							& > span {
								transform: translate(0, 0);
							}
						}
					}
				}
				.text-1 {
					max-width: var(--sp50x);
					transform: translateX(0);
				}
				
				.texts {
					.text-2 {
						max-width: var(--sp50x);
					}
					
					.text-3 {
						max-width: var(--sp60x);
					}
				}
			}
		}

		.exhibition {
			padding:var(--sp15x) 0;
			
			.table {
				margin-top: var(--sp3x);

				.table-heading {
					padding-bottom: var(--sp3x);
				}

				.works {
					.single-work {
						padding:var(--sp3x) var(--containerPadding);
					}
				}
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		.top-section {
			padding-bottom: var(--sp12x);

			.imageCont {

				& > span {
					transition: var(--trTime) cubic-bezier(.66, 0, 0.34, 1);
				}

				&.picture1,
				&.picture3,
				&.butterfly1,
				&.elephant,
				&.coin {
					display:none;
				}

				&.picture2 {
					width: 48%;
					padding-top: 48%;
					left: -22%;
					top: 37%;

					&.activeImage {
						& > span {
							transform: translate(0, 0);
						}
					}
				}

				&.butterfly2 {
					width: 28%;
					padding-top: 28%;
					left: -15%;
					top: 60%;

					&.activeImage {
						& > span {
							transform: translate(0, 0);
						}
					}
				}

				&.angel {
					width: 34%;
					padding-top: 35%;
					left: 0%;
					top: 70%;

					&.activeImage {
						& > span {
							transform: translate(0, 0);
						}
					}
				}
			}

			.Title {
				margin:var(--sp6x) 0 var(--sp3x);
			}

			.text-1 {
				max-width: unset;
				transform: translateX(0);
				padding:0 var(--sp2x);
			}
			
			.texts {
				transform: translateX(0);
				padding:0 var(--sp2x);
				width: 69%;
				align-self: flex-end;

				.text-2 {
					max-width: unset;
					margin:var(--sp3x) 0 var(--sp4x);
				}
				
				.text-3 {
					max-width: unset;
				}
			}
		}

		.exhibition {
			padding:var(--sp12x) 0;
			
			.table {
				margin-top: var(--sp3x);
				overflow-x: scroll;
				.table-heading {
					width: var(--sp96x);
					padding-bottom: var(--sp3x);
					.gallery {
						width: 40%;
					}
				}
				
				.works {
					width: var(--sp96x);					
					.single-work {
						padding:var(--sp3x) var(--containerPadding);
						.city {
							width: 19.2%;
						}
						.year {
							width: 14.4%;
						}
						.ex {
							width: 28.4%;
						}
					}
				}
			}
		}
	}
`
export default ExhibitionsStyle
